import { DBRecords } from "../models/db";
import { entrezConfig } from "./entrezConfig";

export function parseDBRecordsFromDocJSON(result: any): DBRecords {
  var dbColumns: any[] = [];
  var dbRows: any[] = [];
  // console.log(result);

  try {
    if (result === undefined) return { dbColumns, dbRows };

    var uids = result.uids;

    // console.log(uids);
    if (Array.isArray(uids) && uids.length > 0) {
      //get all keys of first uid object as columns

      var obj = result[uids[0]];

      dbColumns = Object.keys(obj).map((key: any) => {
        return { Header: key, accessor: key };
      });

      //get data for all uids
      dbRows = uids.map((uid, index) => {
        const obj = result[uid];

        var dataValues: any = {};
        for (const [key, value] of Object.entries(obj)) {
          var val: any = "";
          if (Array.isArray(value)) {
            val = getArrayData(value);
          } else if (typeof value === "object") {
            val = getObjectData(value);
          } else {
            val = getStringValue(value);
          }
          dataValues[key] = val;
        }
        return dataValues;
      });
    }
  } catch (error) {
    console.log("parseDBRecordsFromDocJSON: Inside the catch");
    console.log(error);
  }

  //console.log(dbColumns);
  //console.log(dbRows);
  return { dbColumns, dbRows };
}

function getStringValue(value: any): string {
  return value.toString();
}

function getArrayData(arr: any[]): string {
  var columns: any = [];

  var result = arr.map((item) => {
    if (typeof item === "string") {
      return item;
    } else if (typeof item === "object") {
      var lValues: any = [];
      for (const [key, value] of Object.entries(item)) {
        
        // not to include certain columns in data
        if (entrezConfig.ExcludeColumns.includes(key)) {
          continue;
        }

        if (!columns.includes(key)) {
          columns.push(key);
        }
        var val: any = "";
        if (!Array.isArray(value)) {
          val = value;
        }

        if (typeof val === "string" && val.length === 0) {
          continue;
        }

        lValues.push(val);
      }

      lValues = lValues.join(", ");

      return lValues;
    }
    return "";
  });
  // columns.join(", ") + ": " +
  var finalData = result.join(", ");
  return finalData;
}

function getObjectData(obj: any): string {
  var lValues: any = [];

  for (const [key, value] of Object.entries(obj)) {
    var convertedValue = "";
    if (typeof value === "object") {
      convertedValue = getObjectData(value);
    } else if (Array.isArray(value)) {
      convertedValue = getArrayData(value);
    } else {
      convertedValue = getStringValue(value);
    }

    lValues.push(key + ": " + convertedValue);
  }

  return lValues.join(", ");
}